import $ from 'gridstrap/lib/gs-zepto';

export class GSHeaderPhoneNumber {
	private root;

	constructor(root) {
		this.root = $(root);
	}

	get isHidden() { return this.root.hasClass('d-none'); }
	set isHidden(value) { this.root.toggleClass('d-none'); }
}
